<div id="login_modal" class="" role="dialog">
    <div class="modal-content plain_bg">
        <div class="modal-body mt-5 mb-5">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true"><i class="fa-solid fa-xmark" (click)="dismiss()"></i></span>
            </button>
            <div class="row">
                <div class="col-md-12">
                    <div class="login_here">
                        <form id="login-form" class="form_login" [formGroup]="googleReview">
                            <!-- <h3 class="text-center"><img loading="lazy" src="../../../../assets/images/new/myvip_logo.png"></h3> -->
                            <h3 class="text-center">Add Review</h3>
                            <br>
                            <!-- <p class="forgot mb-4">Your email must be the same as the one you used to resigter yourself at MYVIP.</p> -->
                            <div class="form-group">
                                <!-- <div class="right_side_feedback">
                                    <a *ngFor="let name of url_names">{{name.urlName}} - {{name.name}}</a>
                                </div> -->
                                <select class="form-control" formControlName="feedbackName">
                                    <option value="" selected disabled>Select name</option>
                                    <option *ngFor="let url of url_names" value="{{url.id}}">{{url.urlName}} - {{url.name}}</option>
                                </select>
                                <ng-container *ngIf="submitted && googleReviewV.feedbackName.errors">
                                    <p class="error-message" *ngIf=" googleReviewV.feedbackName.errors.required">
                                        Please select name.
                                    </p>
                                </ng-container>
                                <br>
                                <textarea class="form-control" formControlName="feedback" placeholder="Write feedback"></textarea>
                                <ng-container *ngIf="submitted && googleReviewV.feedback.errors">
                                    <p class="error-message" *ngIf=" googleReviewV.feedback.errors.required">
                                        Please enter feedback.
                                    </p>
                                </ng-container>
                                <div class="feedback_rating pt-0">
                                    <p>
                                        <ngb-rating [(rate)]="currentRate" max="5" class="gift"></ngb-rating>
                                    </p>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="row align-items-center">
                                    <div class="col-md-12 text-center">
                                        <div class="login_button mt-4">
                                            <a class="btn_design sing_in_btn" (click)="add_google_review()"> Submit </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>